export default "__VITE_ASSET__2laU8yyY__"